<template>
    <div class="modal-content">

        <div class="modal-header p-d-flex p-p-3" v-if="title">

            <div class="p-mr-2">
               <h2 class="modal-title">{{$t(title)}}</h2>
            </div>

            <div class="p-ml-auto">
                <slot name="actions"></slot>

                <a class="pointer" href :title="$t('modal.buttons.close')" @click.prevent="closeModal()">
                    <i class="pi pi-times"></i>
                </a>
            </div>

        </div>

        <div id="overlay" v-if="loading">
            
        </div>

        <div class="modal-body p-mr-2 p-ml-2" ref="modal_body" :class="{'has-footer' : hasFooter}">
            <slot></slot>
        </div>

        <div class="modal-footer" v-if="hasFooter">
            <div class="p-d-flex">
                <slot name="footer"></slot>
            </div>
        </div>

    </div>

</template>

<script>

    import ModalBusiness from "@/business/ModalBusiness";

    export default {
        name: "AncestrylineModal",
        props: {
            title: String,
            loading: Boolean,
            close: Boolean,
            check: {type: Boolean, default: false},
            closeable: {type: Boolean, default: true},
            closeEsc: {type: Boolean, default: false},
        },

        data() {
            return {}
        },

        computed: {
            hasFooter() {
                return !!this.$slots.footer;
            }
        },
        mounted() {
            this.$nextTick(function () {
                let elements = (this.$refs.modal_body).querySelectorAll('input, input.form-check-input, select, textarea')
                if (Object.keys(elements).length > 0) elements[0].focus()
            })
            document.addEventListener("keydown", this.escClose);
        },
        beforeDestroy() {
            document.removeEventListener('keydown', this.escClose)
        },

        methods: {
            closeModal() {
                if (!this.close) {
                    ModalBusiness.closeModal();
                } else {
                    this.$emit('close');
                }
            },
            escClose(e) {
                if (e.keyCode === 27 && this.closeEsc) {
                    ModalBusiness.closeModal();
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

    .modal-content {

        #overlay {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.55);
            z-index: 2;
        }

        .modal-header, .modal-content, .modal-footer {

        }

        .modal-header, .modal-footer {

            padding: .75rem 1rem;

        }

        .modal-header {

            .modal-title{
                font-weight: 500;
                font-size: 1.1rem;
            }

        }

        .modal-body{
            max-height: calc(100vh - 200px);
            overflow: auto;
            min-height: 340px;
        }

        .modal-footer{

        }

    }

</style>
